export type QuestionType = {
  question: string;
  answer: string;
  answers: string[];
  extraAnswers: string[];
  extraExtraAnswers: string[];
  numberedAnswers: string[];
  links: FaqLink[];
};

export type FaqLink = {
  name: string;
  label: string;
  href: string;
};

export const TABS_ICONS: { [key in string]: string } = {
  Account: "cog",
  Slots: "calendar",
  Trips: "collection",
  Operate: "process",
  Earnings: "currency-dollar",
  RoadSafety: "motorbike",
};
